module.exports = __webpack_public_path__ + "static/media/philippines.72005df5.jpeg";